export default {
  brand: {
    50: '#ecf3f5',
    100: '#c5dbec',
    200: '#a4c1db',
    300: '#83a9c9',
    400: '#6090b8',
    500: '#47769f',
    600: '#355c7c',
    700: '#24425a',
    800: '#122739',
    900: '#000e1a',
  },
  card: {
    50: '#f0f0f0',
  },
};
